import React from 'react';
import { cn } from '../../lib/utils';

export function Badge({ status, className }) {
  const styles = {
    'En Oferta': 'bg-brand-oferta-bg text-brand-oferta-text',
    'Vigilar': 'bg-brand-vigilar-bg text-brand-vigilar-text',
    'Sobrevalorado': 'bg-brand-sobrevalorado-bg text-brand-sobrevalorado-text',
    'Sin datos': 'bg-gray-100 text-gray-600',
    gray: 'bg-gray-100 text-gray-600',
  };

  // Status indicator dot color
  const dots = {
    'En Oferta': 'bg-green-500',
    'Vigilar': 'bg-yellow-500',
    'Sobrevalorado': 'bg-red-500',
    'Sin datos': 'bg-gray-400',
    gray: 'bg-gray-400',
  };

  const label = status === 'gray' ? 'Sin datos' : status;

  return (
    <span className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", styles[status] || styles['Vigilar'], className)}>
      <span className={cn("w-2 h-2 rounded-full mr-1.5", dots[status] || dots['Vigilar'])}></span>
      {label}
    </span>
  );
}